<template>
  <!-- ! Debt Solution Is Enabled -->
  <v-container
    fluid
    id="debt-solutions-section"
    class="maxWidthSet px-0"
    v-if="debtSolutionsEnabled"
  >
    <DebtSolutionsCardTitle />
    <v-card>
      <LoadingIndicator v-if="step === -1" :loading="step === -1" />
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <!-- Top portion -->
            <DebtSolutionsNoPlanTop v-if="debtsolutionsStore.hasNoPlan" />
            <!-- 2 or more debts -->
            <DebtSolutionsV03Top
              v-if="
                debtsolutionsStore.hasActivePlan &&
                debtsolutionsStore.twoOrMoreDebtsAndMinOneUnpaidDebt
              "
            />
            <!-- Only 1 debt -->
            <DebtSolutionsV03TopSingle
              v-if="
                debtsolutionsStore.hasActivePlan &&
                !debtsolutionsStore.twoOrMoreDebtsAndMinOneUnpaidDebt
              "
            />
            <DebtSolutionsCongratsTop v-if="debtsolutionsStore.hasCompletedPlan" />
          </v-col>
          <v-col cols="12">
            <!-- Bottom portion -->
            <DebtSolutionsNoPlanBottom v-if="debtsolutionsStore.hasNoPlan" />
            <!-- 2 or more debts -->
            <DebtSolutionsV03Bottom
              v-if="
                debtsolutionsStore.hasActivePlan &&
                debtsolutionsStore.twoOrMoreDebtsAndMinOneUnpaidDebt
              "
            />
            <!-- Only 1 debt -->
            <DebtSolutionsV03BottomSingle
              v-if="
                debtsolutionsStore.hasActivePlan &&
                !debtsolutionsStore.twoOrMoreDebtsAndMinOneUnpaidDebt
              "
            />
            <DebtSolutionsCongratsBottom v-if="debtsolutionsStore.hasCompletedPlan" />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import DebtSolutionsCardTitle from './components/DebtSolutionsCardTitle.vue';
import DebtSolutionsNoPlanTop from './components/DebtSolutionsNoPlanTop.vue';
import DebtSolutionsNoPlanBottom from './components/DebtSolutionsNoPlanBottom.vue';
import DebtSolutionsV03Top from './components/DebtSolutionsV03Top.vue';
import DebtSolutionsV03Bottom from './components/DebtSolutionsV03Bottom.vue';
import DebtSolutionsV03TopSingle from './components/DebtSolutionsV03TopSingle.vue';
import DebtSolutionsV03BottomSingle from './components/DebtSolutionsV03BottomSingle.vue';
import DebtSolutionsCongratsTop from './components/DebtSolutionsCongratsTop.vue';
import DebtSolutionsCongratsBottom from './components/DebtSolutionsCongratsBottom.vue';
import LoadingIndicator from '@/components/LoadingIndicator.vue';
import { useGlobalStore } from '@/stores/global/global.store';
import { FEATURE_FLAGS } from '@/shared/models/constants.models';
import { useCustomerStore } from '@/stores/customer/customer.store';
import { useDebtSolutionsStore } from '@/modules/debtsolutions/store/debtsolutions.store';
import { mapState, mapStores } from 'pinia';
import { OnexButton } from '@primerica/onex-ui-lib';

const componentOptions: ComponentOptions = {
  name: 'DebtSolutionsCard',
  components: {
    DebtSolutionsCardTitle,
    DebtSolutionsNoPlanTop,
    DebtSolutionsNoPlanBottom,
    DebtSolutionsV03Top,
    DebtSolutionsV03Bottom,
    DebtSolutionsV03TopSingle,
    DebtSolutionsV03BottomSingle,
    DebtSolutionsCongratsTop,
    DebtSolutionsCongratsBottom,
    LoadingIndicator,
    OnexButton,
  },
  computed: {
    ...mapStores(useGlobalStore, useCustomerStore, useDebtSolutionsStore),
    ...mapState(useGlobalStore, ['containsFeature']),
    debtSolutionsEnabled() {
      return this.containsFeature(FEATURE_FLAGS.DEBT_SOLUTIONS);
    },
    step() {
      return this.debtsolutionsStore.step;
    },
  },
  async mounted() {
    try {
      if (this.step === undefined || this.step === -1) {
        await this.debtsolutionsStore.debtInit();
        this.debtsolutionsStore.step = 1;
      } else if (
        this.customerStore.investments?.calculator?.scenario?.retirement?.age !==
        this.debtsolutionsStore.personInfo?.retirementAge
      ) {
        this.debtsolutionsStore.debtInit();
      }
    } catch (_e) {
      this.debtsolutionsStore.step = 1;
    }
  },
};

export default defineComponent(componentOptions);
</script>

<style lang="scss" scoped>
.maxWidthSet {
  max-width: 1024px;
  margin: auto;
}
.bottom {
  background: #d6d6d6;
}
.box {
  background-image: url('./assets/debt-freedom-image.png');
  background-position-x: center;
  background-size: cover;
  text-align: center;
  padding: 0 0 30px 0;
}
</style>
